type ThrottledFunction<T extends (...args: any[]) => void> = (
	...args: Parameters<T>
) => void;

export function throttle<T extends (...args: any[]) => void>(
	mainFunction: T,
	delay: number
): ThrottledFunction<T> {
	let timerFlag: ReturnType<typeof setTimeout> | null = null;

	return (...args: Parameters<T>) => {
		if (timerFlag === null) {
			mainFunction(...args);
			timerFlag = setTimeout(() => {
				timerFlag = null;
			}, delay);
		}
	};
}
